module.exports = __webpack_public_path__ + "img/p7.98d638a1.jpg";